module.exports = __webpack_public_path__ + "static/media/nsf-logo-small.f9db4e2e.png";